const externalSystemImportMapping = Object.freeze({
    None: -1,
    Agrimatics: 0,
    JohnDeere: 1,
})

export default externalSystemImportMapping